const supAdminNav = [
  { name: "Dashboard", path: "/dashboard" },
  { name: "Stock Management", path: "/stock" },
  { name: "Product Management", path: "/products" },
  { name: "Category", path: "/category" },
  { name: "Inventory", path: "/inventory" },
  { name: "Department", path: "/department" },
  { name: "Designation", path: "/designation" },
  { name: "Supplier", path: "/supplier" },
  { name: "Routee", path: "/routee" },
  { name: "Customer", path: "/customer" },
  { name: "Cash Management", path: "/cash" },
  { name: "Employees", path: "/employees" },
  { name: "Create Sales", path: "/CreateSaleModal" },
  { name: "Sales", path: "/sales" },
  { name: "Expenses", path: "/expenses" },
  { name: "Credit", path: "/credit" },
  { name: "Payments", path: "/cashh" },
  { name: "Cheque", path: "/cheque" },
  { name: "User", path: "/user" },
];

export default supAdminNav;
